import * as d3 from 'd3';

import { ElementRender } from '../CategoricalChart/ElementeRenderer';
import { LineDefinition, renderLines } from '../CategoricalChart/renderLines';

export class VerticalLines extends ElementRender {
    private _classes: string;
    constructor(selection: d3.Selection<any>, classed: string) {
        super(selection, classed);
    }

    classes(): string;
    classes(value: string): this;
    classes(value?: string) {
        if (!arguments.length) {
            return this._classes;
        }
        this._classes = value;
        return this;
    }

    render(ticks: { x: number, color?: string }[]) {
        const lines: LineDefinition[] = ticks.map(t => {
            return {
                x1: t.x, x2: t.x, y1: 0, y2: this.height(), color: t.color
            };
        });
        renderLines(lines, this.container(), this.visible(), this._classes);
    }
}